import { Component, inject } from '@angular/core';

import { NewAccountComponent } from '../../new-account.component';

@Component({
  selector: 'app-new-account-desktop-form-state',
  templateUrl: './new-account-desktop-form-state.component.html',
  styleUrls: [
    '../../shared-styles/new-account-device-view.component.scss',
    './new-account-desktop-form-state.component.scss',
  ],
  standalone: false,
})
export class NewAccountDesktopFormStateComponent {
  public readonly newAccount = inject(NewAccountComponent);
}
